export default {"src":"/_next/static/media/OKB.15dd6888.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};